import { render, staticRenderFns } from "./UploadFileInput.vue?vue&type=template&id=85193c14&scoped=true&"
import script from "./UploadFileInput.vue?vue&type=script&lang=js&"
export * from "./UploadFileInput.vue?vue&type=script&lang=js&"
import style0 from "./UploadFileInput.vue?vue&type=style&index=0&id=85193c14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85193c14",
  null
  
)

export default component.exports